import React, { useState } from "react";
import ExlyMoneyInput from "common/form/ExlyMoneyInput";
import { Checkbox } from "@my-scoot/component-library-legacy";
import constants from "constants/constants";
import {
  MEMBERSHIP_OFFERING_PRICE_CHOICES,
  OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS,
} from "ui/pages/ManageBrandedCommunity/components/AddBonusOfferingModal/constants/AddBonusOfferingModal.constants";
import { useAddVariations } from "../../utils/hooks/useAddVariation";

export const DiscountedPriceField = ({ membershipId = null }) => {
  const {
    selectedOption,
    handlePriceValueChange,
    getMembershipPriceFieldsById,
    onEnableInternationalPriceClick,
    validatePrice,
    errorObj,
    setErrorObj,
  } = useAddVariations();

  const [enableInternationalPrice, setEnableInternationalPrice] = useState(
    getMembershipPriceFieldsById({
      fieldKey: OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS.enableInternationalPrice,
      membershipId,
    })
  );
  const atDiscountedPriceSelected = selectedOption({
    optionKey: MEMBERSHIP_OFFERING_PRICE_CHOICES.AT_DISCOUNTED_PRICE,
    membershipId,
  });

  const handleInternationalToggle = () => {
    onEnableInternationalPriceClick({
      value: !enableInternationalPrice,
      membershipId,
    });
    setEnableInternationalPrice(!enableInternationalPrice);
  };

  return atDiscountedPriceSelected ? (
    <div className="tw-w-full">
      <div className="tw-mt-2">
        <ExlyMoneyInput
          input={{
            value: getMembershipPriceFieldsById({
              fieldKey: OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS.discountedPrice,
              membershipId,
            }),
            onChange: (e) => {
              handlePriceValueChange({
                e,
                fieldKey: OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS.discountedPrice,
                membershipId,
              });
            },
          }}
          onBlur={() =>
            setErrorObj({
              ...errorObj,
              domesticPrice: true,
            })
          }
          size="small"
          placeholder="Enter new discounted price..."
          type="number"
          fullWidth
          meta={{
            touched: errorObj.domesticPrice,
            error: validatePrice({
              price: getMembershipPriceFieldsById({
                fieldKey: OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS.discountedPrice,
                membershipId,
              }),
            }),
          }}
          symbol={constants.inr_currency}
        />
      </div>
      <div className="tw-flex tw-mt-2">
        <Checkbox
          size="large"
          checked={!!enableInternationalPrice}
          onChange={handleInternationalToggle}
          wrapperClassName="tw-mt-[2px] mr-2"
        />
        <span
          className="tw-text-sm tw-pointer"
          onClick={handleInternationalToggle}
        >
          Set a different price for International customers
        </span>
      </div>
      {enableInternationalPrice ? (
        <div className="tw-mt-2">
          <ExlyMoneyInput
            input={{
              value: getMembershipPriceFieldsById({
                fieldKey:
                  OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS.internationalPrice,
                membershipId,
              }),
              onChange: (e) => {
                handlePriceValueChange({
                  e,
                  fieldKey:
                    OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS.internationalPrice,
                  membershipId,
                });
              },
            }}
            onBlur={() =>
              setErrorObj({
                ...errorObj,
                internationalPrice: true,
              })
            }
            size="small"
            placeholder="Enter new discounted price..."
            type="number"
            fullWidth
            meta={{
              touched: errorObj.internationalPrice,
              error: validatePrice({
                price: getMembershipPriceFieldsById({
                  fieldKey:
                    OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS.internationalPrice,
                  membershipId,
                }),
              }),
            }}
            symbol={constants.usd_currency}
          />
        </div>
      ) : null}
    </div>
  ) : null;
};
